import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { Reveal } from "./Primitives";
import { plans } from "@/lib/siteData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TECH_BG = "https://images.unsplash.com/photo-1669829691103-597ab330aaa2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxuZW9uJTIwc2VydmVyJTIwcm9vbSUyMHRlY2glMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjIwNDgzNXww&ixlib=rb-4.1.0&q=85";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", plan: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Preencha nome e e-mail.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, form);
      toast.success("Recebemos seu contato! Vamos te chamar em breve. 🚀");
      setForm({ name: "", email: "", phone: "", plan: "", message: "" });
    } catch (err) {
      toast.error("Erro ao enviar. Tente novamente ou fale no WhatsApp.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 font-body text-white placeholder:text-slate-500 transition-colors focus:border-[#06B6D4] focus:outline-none focus:ring-2 focus:ring-[#06B6D4]/20";

  return (
    <section id="contato" className="relative mx-auto max-w-7xl px-4 py-24 md:px-8 md:py-32">
      <div className="grid grid-cols-1 overflow-hidden rounded-3xl border border-white/8 lg:grid-cols-2">
        <Reveal className="bg-[#0F0F1A] p-8 md:p-12">
          <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-cyan-400">// Fale conosco</span>
          <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter md:text-4xl">
            Peça seu teste grátis
          </h2>
          <p className="mt-3 font-body text-slate-400">
            Deixe seus dados e nosso time entra em contato para liberar seu acesso.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <input data-testid="contact-name" className={inputCls} placeholder="Seu nome" value={form.name} onChange={set("name")} />
            <input data-testid="contact-email" type="email" className={inputCls} placeholder="Seu melhor e-mail" value={form.email} onChange={set("email")} />
            <input data-testid="contact-phone" className={inputCls} placeholder="WhatsApp (opcional)" value={form.phone} onChange={set("phone")} />
            <select data-testid="contact-plan" className={inputCls} value={form.plan} onChange={set("plan")}>
              <option value="" className="bg-[#0F0F1A]">Plano de interesse (opcional)</option>
              {plans.map((p) => (
                <option key={p.name} value={p.name} className="bg-[#0F0F1A]">{p.name}</option>
              ))}
            </select>
            <textarea data-testid="contact-message" rows={3} className={inputCls} placeholder="Mensagem (opcional)" value={form.message} onChange={set("message")} />
            <button
              data-testid="contact-submit"
              type="submit"
              disabled={loading}
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#8B5CF6] to-[#7c3aed] px-6 py-4 font-display font-bold text-white transition-transform hover:scale-[1.02] disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-5 w-5" />}
              {loading ? "Enviando..." : "Quero meu teste"}
            </button>
          </form>
        </Reveal>

        <div className="relative min-h-[300px]">
          <img src={TECH_BG} alt="Servidores" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#05050A] via-[#05050A]/40 to-transparent" />
          <div className="absolute bottom-0 p-8 md:p-12">
            <div className="font-display text-2xl font-black">Infraestrutura de ponta</div>
            <p className="mt-2 font-body text-slate-300">
              Servidores dedicados garantindo estabilidade e velocidade para você assistir sem travar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
